// @ts-check
/* ═══════════════════════ STATE + STORAGE ═══════════════════════
   Sentral state og localStorage-persistens.
   `setSaveHook` lar andre moduler (f.eks. cloud.js) reagere på
   lokale lagringer — erstatter den gamle monkey-patchingen.
   Typer: se src/types/state.ts
════════════════════════════════════════════════════════════════ */

/** @type {import('./types/state.ts').AppState} */
export const S = {
  tab:"idag",sub:"oversikt",openDay:null,openAcc:null,destIdx:null,filter:"Alle",
  acts:[],chk:{},packChk:{},
  budgetEntries:[],budgetTarget:6000,
  diary:[],diaryEdit:null,diaryAuthor:"",
  comments:{},
  reactions:{},
  commentName:"",
  chatMsgs:[{role:"ai",content:"Hei! Jeg kjenner hele turen – Vancouver, Alaska-cruise med Celebrity Solstice, og bilturen gjennom Rocky Mountains til Calgary. 🍁\n\nNy i denne versjonen: sjekk Verktøy-fanen for tidsoner, valutakalkulator og drivstoffkalkulator! Spør meg om hva som helst."}],
  chatLoading:false,editId:null,editType:null,form:{},merOpen:false,toolTab:"clock",
  destAiMsgs:[],destAiLoading:false,bookingsOpen:false,
  notifEnabled:false,notifLastDate:"",
  familyName:"",syncEnabled:false,lastSync:null,
};

/** @type {import('./types/state.ts').SaveHook | null} */
let onSave = null;
/** @param {import('./types/state.ts').SaveHook} fn */
export function setSaveHook(fn){ onSave = fn; }
/** @param {import('./types/state.ts').SaveType} type */
function fire(type){ try { onSave?.(type); } catch (e) { console.warn("save hook error", e); } }

export function loadStorage(){
  try{const a=localStorage.getItem("ca26acts");if(a)S.acts=JSON.parse(a);}catch{}
  try{const c=localStorage.getItem("ca26chk");if(c)S.chk=JSON.parse(c);}catch{}
  try{const p=localStorage.getItem("ca26pack");if(p)S.packChk=JSON.parse(p);}catch{}
  try{const b=localStorage.getItem("ca26budget");if(b)S.budgetEntries=JSON.parse(b);}catch{}
  try{const t=localStorage.getItem("ca26btarget");if(t)S.budgetTarget=parseFloat(t);}catch{}
  try{const d=localStorage.getItem("ca26diary");if(d)S.diary=JSON.parse(d);}catch{}
  try{const a=localStorage.getItem("ca26author");if(a)S.diaryAuthor=a;}catch{}
  try{const c=localStorage.getItem("ca26comments");if(c)S.comments=JSON.parse(c);}catch{}
  try{const r=localStorage.getItem("ca26reactions");if(r)S.reactions=JSON.parse(r);}catch{}
  try{const n=localStorage.getItem("ca26cname");if(n)S.commentName=n;}catch{}
  try{const ne=localStorage.getItem("ca26notif");if(ne)S.notifEnabled=ne==="1";}catch{}
  try{const nl=localStorage.getItem("ca26notiflast");if(nl)S.notifLastDate=nl;}catch{}
  try{const fn=localStorage.getItem("ca26fname");if(fn)S.familyName=fn;}catch{}
  try{const se=localStorage.getItem("ca26sync");if(se)S.syncEnabled=se==="1";}catch{}
}

export function saveActs(){try{localStorage.setItem("ca26acts",JSON.stringify(S.acts));}catch{} fire("acts");}
export function saveChk(){try{localStorage.setItem("ca26chk",JSON.stringify(S.chk));}catch{} fire("chk");}
export function savePackChk(){try{localStorage.setItem("ca26pack",JSON.stringify(S.packChk));}catch{} fire("pack");}
export function saveBudget(){try{localStorage.setItem("ca26budget",JSON.stringify(S.budgetEntries));}catch{} fire("budget");}
export function saveDiary(){try{localStorage.setItem("ca26diary",JSON.stringify(S.diary));}catch{} fire("diary");}
export function saveComments(){try{localStorage.setItem("ca26comments",JSON.stringify(S.comments));}catch{} fire("comments");}
export function saveReactions(){try{localStorage.setItem("ca26reactions",JSON.stringify(S.reactions));}catch{} fire("reactions");}
